// extracted by mini-css-extract-plugin
module.exports = {"container":"InputWithTextPlaceholder_container__110_P","wrapper":"InputWithTextPlaceholder_wrapper__Cg_jb"};